import { Skeleton as NovaSkeleton } from '@fme-nova/components'
import { default as MuiBaseSkeleton, SkeletonProps } from '@mui/material/Skeleton'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

export const MuiSkeleton: MsdkStyledComponent<SkeletonProps> = styled(MuiBaseSkeleton)``

export const Skeleton = createComponentWrapperWithRef<SkeletonProps>(
  {
    mui: MuiSkeleton,
    nova: NovaSkeleton,
  },
  'Skeleton',
)
